var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"intro",staticClass:"intro"},[_c('button',{staticClass:"intro__skip",on:{"click":_vm.skip}}),_c('canvas',{ref:"oscilloscope",staticClass:"intro__canvas oscilloscope"})])
}
var staticRenderFns = []

export { render, staticRenderFns }